import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=cd75f322&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordDetail.vue?vue&type=style&index=0&id=cd75f322&prod&lang=css"
import style1 from "./RecordDetail.vue?vue&type=style&index=1&id=cd75f322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd75f322",
  null
  
)

export default component.exports